/**
 * Возраст — точное число, а не категория: пользователь указывает свой возраст
 * шкалой 18–99 и отдельно задаёт диапазон возраста собеседника.
 */
export const MIN_AGE = 18;
export const MAX_AGE = 99;
/** Ширина корзины возраста в ключе очереди Redis. */
export const AGE_BUCKET_SIZE = 5;
export function isValidAge(age) {
    return Number.isInteger(age) && age >= MIN_AGE && age <= MAX_AGE;
}
export function clampAge(age) {
    return Math.min(MAX_AGE, Math.max(MIN_AGE, Math.round(age)));
}
/** Приводит диапазон к допустимому виду: границы в пределах 18–99 и min ≤ max. */
export function normalizeAgeFilter(filter) {
    const min = clampAge(filter?.min ?? MIN_AGE);
    const max = clampAge(filter?.max ?? MAX_AGE);
    return min <= max ? { min, max } : { min: max, max: min };
}
export function ageMatchesFilter(age, filter) {
    return age >= filter.min && age <= filter.max;
}
/**
 * Номер корзины возраста. Корзины нужны только для раскладки очереди по ключам
 * Redis: точный возраст всё равно проверяется при подборе, а корзины дают
 * ограниченный сверху набор ключей вместо одного ключа на каждый год.
 */
export function ageBucket(age) {
    return Math.floor((clampAge(age) - MIN_AGE) / AGE_BUCKET_SIZE);
}
export const AGE_BUCKET_COUNT = ageBucket(MAX_AGE) + 1;
/** Корзины, пересекающиеся с диапазоном поиска. */
export function bucketsForFilter(filter) {
    const from = ageBucket(filter.min);
    const to = ageBucket(filter.max);
    const buckets = [];
    for (let bucket = from; bucket <= to; bucket += 1) {
        buckets.push(bucket);
    }
    return buckets;
}
/** Подпись диапазона для интерфейса: «25–34», «18+», «до 30». */
export function formatAgeFilter(filter) {
    if (filter.min === MIN_AGE && filter.max === MAX_AGE) {
        return `${MIN_AGE}–${MAX_AGE}`;
    }
    if (filter.max === MAX_AGE) {
        return `${filter.min}+`;
    }
    if (filter.min === MIN_AGE) {
        return `до ${filter.max}`;
    }
    return `${filter.min}–${filter.max}`;
}
/**
 * Расширение диапазона при долгом ожидании. Пол и тема не ослабляются никогда,
 * возраст — расширяется симметрично на заданное число лет.
 */
export function widenAgeFilter(filter, years) {
    if (years <= 0) {
        return filter;
    }
    return normalizeAgeFilter({ min: filter.min - years, max: filter.max + years });
}
//# sourceMappingURL=age.js.map